import React, { useMemo } from 'react'
import AccountProfileHeader from './AccountProfileHeader'
import AccountMenuList from './AccountMenuList'
import { getAccountNavItems } from './accountNavItems'
import { cn } from '../../lib/utils'

const AccountProfileSidebar = ({
  profile,
  activeId,
  referralActive = false,
  hasVod = false,
  onAction,
  className
}) => {
  const items = useMemo(() => getAccountNavItems({ referralActive, hasVod }), [
    referralActive,
    hasVod
  ])

  return (
    <aside
      className={cn(
        'flex flex-col overflow-hidden rounded-xl border border-border bg-background',
        className
      )}
    >
      <AccountProfileHeader
        profile={profile}
        variant="sidebar"
        showEdit={false}
      />
      <div className="mt-2 px-3">
        <AccountMenuList
          items={items.filter(item => item.id !== 'logout')}
          activeId={activeId}
          variant="sidebar"
          onAction={onAction}
        />
      </div>
      <div className="mt-3 border-t border-border px-3 pb-3 pt-3">
        <AccountMenuList
          items={items.filter(item => item.id === 'logout')}
          variant="sidebar"
          onAction={onAction}
        />
      </div>
    </aside>
  )
}

export default AccountProfileSidebar
